<template>
	<div id="inputSearchIntelligentComponent">
		<button @click="clearSearch" ref="btnClearSearch" v-show="false">Limpiar Search</button>
		<button @click="setSearch" ref="btnSetSearch" v-show="false">Setear Search</button>
		<button @click="realizeAnalysis" ref="btnRealizeAnalysis" v-show="false">Realizar analisis</button>
		<button @click="setFocus" ref="btnSetFocus" v-show="false">Setear el Focus</button>
		<input type="text"
			:class="_class"
			:style="_style"
			:placeholder="_placeholder"
			v-model="search"
			@keyup="eventKeyup"
			ref="inputSearch">
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import commands from '@/mixins/commands'

	export default {
		name: 'InputSearchIntelligentComponent',
		mixins: [mixin, commands],
		props: ['minCharsAnalyze', 'analyzeAuto', 'trim', '_class', 'clearEnter', 'str', '_placeholder', '_style'],
		data () {
			return {
				contador: 0,
				lengthISBN: 13,
				lengthSE: 20, 
				lengthMA: 9, 
				result: null,
			}
		},
		computed: {
			getAnalyzeAuto() { // Determina si se analiza por cada caracter precionado (default = false)
				if(typeof this.analyzeAuto == "boolean")
					return this.analyzeAuto
				return false
			},
			getClearEnter() { // Determina si tiene que limpiar search al hacer enter (default = true)
				if(typeof this.clearEnter == "boolean")
					return this.clearEnter
				return true
			},
			getMinCharsAnalyze() { // Determina cual es el largo minimo para analizar el contenido (default = 3)
				if(this.minCharsAnalyze != undefined && this.minCharsAnalyze != null && !isNaN(this.minCharsAnalyze))
					return this.minCharsAnalyze
				return 3
			},
			getTrim() { // Determina si hay que borrar los espacios en blanco del inicio y termino para su analisis (default = true)
				if(typeof this.trim == "boolean")
					return this.trim
				return true
			}
		},
		methods: {
			initComponent() {
				this.getCommandsByTypeLocal()
			},
			clearSearch() {
				this.search = ''
			},
			getCommandsByTypeLocal() {
				this.message = 'Estamos cargando los comandos generales. . .'
				this.getCommandsByType([1])
			},
			getCommandsByTypeResultLocal(response) {
				if(response.data.success == true) {
					this.setCommandGeneral(response.data.data)
					console.log('Se recuperó con exito los commandos generales!!!')
				}
			},
			setSearch() {
				this.search = (this.str != undefined && this.str != null) ? this.str : ''
			},
			realizeAnalysis() {
				if(this.getAnalyzeAuto && s.length >= this.getMinCharsAnalyze) {
					this.analize(this.search, 'ENTER')
				}
			},
			eventKeyup(e) {
				let s = (this.getTrim) ? this.search.trim() : this.search
				if(e.keyCode == 13 && s.length >= this.getMinCharsAnalyze) {
					this.analize(s)
				}
				if(this.getAnalyzeAuto && s.length >= this.getMinCharsAnalyze && e.keyCode != 13) {
					this.analize(s, 'ALL')
				}
			},
			analize(s, type = 'ENTER') {
				if(type.trim().toUpperCase() == 'ENTER') {
					let command = this.internalAction(s)
					if(command != null) {
						if(command.type_command_id != 0) {
							this.$emit('actionCommand', command)
						}
						return
					}
				}

				this.result = this.analizeIsNumber(s)
				this.result = (this.result == null) ? this.analizeIsSKU(s) : this.result
				this.result = (this.result == null) ? this.analizeIsShippingRequest(s) : this.result
				this.result = (this.result == null) ? this.analizeIsManifesto(s) : this.result
				this.result = (this.result == null) ? this.analizeIsStoreRackSideRowColumn(s) : this.result
				this.result = (this.result == null) ? { result: 'CHARACTER', data: s, original: s } : this.result

				if(type == 'ALL') {
                    this.$emit('actionKeyUp', this.result)
				} else if(type == 'ENTER'){
					this.addHistoryInput(s)
					if(this.getClearEnter) {
						this.clearSearch()
					}
					this.$emit('actionKeyEnter', this.result)
				}
			},
			setFocus() {
				this.$refs.inputSearch.focus()
			},
			analizeIsNumber(s) {
				if(!isNaN(s)) {
					if(this.isInt(s)) {
						return (s.trim().length == this.lengthISBN) ? { result: 'ISBN', data: s.trim(), original: s } : { result: 'INTEGER', data: s, original: s }
					}
					if(this.isFloat(s)) {
						return { result: 'FLOAT', data: s, original: s }
					}
				}
				return null
			},
			analizeIsSKU(s) {
				if(s.trim().length > 1 && s.trim().substring(0, 1).toUpperCase() == 'H' && this.isInt(s.trim().substring(1, s.trim().length)))
					return { result: 'PRODUCT', data: s.trim().substring(1, s.trim().length), original: s }
				return null
			},
			analizeIsShippingRequest(s) {
				if(s.trim().length > 2 && s.trim().substring(0, 2).toUpperCase() == 'SE' && this.isInt(s.trim().substring(2, s.trim().length)) && s.trim().length <= this.lengthSE + 2) {
					let data = s.trim().substring(2, s.trim().length)
					data = (data.length > 16) ? data.substring(0, 16) : data
					return { result: 'SHIPPINGREQUEST', data: data, original: s }
				}
				return null
			},
			analizeIsManifesto(s) {
				if(s.trim().length > 2 && s.trim().substring(0, 2).toUpperCase() == 'MA' && this.isInt(s.trim().substring(2, s.trim().length)) && s.trim().length <= this.lengthMA + 2) {
					let data = s.trim().substring(2, s.trim().length)
					return { result: 'MANIFESTO', data: data, original: s }
				}
				return null
			},
			analizeIsStoreRackSideRowColumn(s) {
				let arr = s.split('.')
				if(arr.length == 5) {
					let result = true
					arr.forEach(element => {
						result = (this.isInt(element) && result) ? true : false
					})
					if(result)
						return { result: 'STORERACKSIDEROWCOLUMN', data: arr[4], original: s }
				}
				return null
			}
		},
		mounted () {
			this.initComponent()
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
